module.exports = __webpack_public_path__ + "img/logo.ce7c4184.png";